import { HOME as idPrefix } from '../../../constants/translates';

const messages = {
  [`${idPrefix}.greeting`]: 'Добро пожаловать на сайт с игрой',
  [`${idPrefix}.formNameLabel`]: 'Введите своё имя',
  [`${idPrefix}.nextStepButton`]: 'Начать игру'
};

export default messages;
